import CloseIcon from "../../images/icon_close.svg";
import Sidebar from "../Sidebar/Sidebar";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import {
  CloseButton,
  Container,
  PMessage,
  StatusCard,
  StatusDiv,
  StatusInfo,
  VolanteInfo,
} from "./InvoiceStatusSidebarStyles";

const calcZIndex = (parentId) => {
  const element = document.getElementById(parentId);
  const elementStyle = element ? window.getComputedStyle(element) : null;
  const elementZIndex = elementStyle
    ? elementStyle.getPropertyValue("z-index")
    : 100;
  const calculateZindex = Number(elementZIndex) + 7;
  return calculateZindex.toString();
};

function StatusSidebar(props) {
  const { volante, onOutsideClick } = props;
  const { status } = volante;
  const { problems, warnings } = status;
  const numberProblems = problems.length;

  return (
    <Sidebar
      onOutsideClick={onOutsideClick}
      zIndex={calcZIndex("vol-aditional-serive-id")}
    >
      <Container>
        <VolanteInfo>
          {volante?.quotationNum && (
            <p className="quotation-id">{`${volante?.quotationNum}`}</p>
          )}
          <CloseButton onClick={onOutsideClick}>
            <img src={CloseIcon} alt="Close" />
          </CloseButton>
          <p className="importer-name">
            {volante.importer || volante.consigneeName}
          </p>
          <StatusDiv status={numberProblems > 0 ? "problem" : "ok"}>
            <span>{`${numberProblems === 0 ? "SIN" : numberProblems} RESTRICCI${
              numberProblems === 1 ? "ÓN" : "ONES"
            }`}</span>
          </StatusDiv>
        </VolanteInfo>
        <StatusInfo>
          {numberProblems === 0 && (
            <StandaloneMessage>
              Este volante no tiene ninguna restricción.
            </StandaloneMessage>
          )}

          {problems.map((problem, index) => {
            return (
              <StatusCard key={index} style={{ cursor: "pointer" }}>
                <StatusDiv status={problem.category}>
                  <span> {problem.label.toUpperCase()}</span>
                </StatusDiv>
                <PMessage>{problem.message}</PMessage>
              </StatusCard>
            );
          })}

          {warnings.map((warning, index) => {
            return (
              <StatusCard key={index} style={{ cursor: "pointer" }}>
                <StatusDiv status={warning.category}>
                  <span>{warning.label.toUpperCase()}</span>
                </StatusDiv>
                <PMessage>{warning.message}</PMessage>
              </StatusCard>
            );
          })}
        </StatusInfo>
      </Container>
    </Sidebar>
  );
}

export default StatusSidebar;
